import $ from 'gridstrap/lib/gs-zepto';

export class GSAddEvent {

  private document;
  private root;

  private providerList;
  private providers;
  private button;

  constructor(root) {

    this.document = $(document);
    this.root   = $(root);

    this.button       = this.root.find('.add-event-button');
    this.providerList = this.root.find('.add-event-provider-list');
    this.providers    = this.root.find('.add-event-provider');

    this.button.on('click', () => this.toggle());
    this.document.on('click', e => this.clickDocument(e));
    this.providers.on('click', e => this.clickProvider(e));

  }

  toggle() {
    this.providerList.toggle().toggleClass('selected')
  }

  clickDocument(e) {
    if (!this.providerList.hasClass('selected')) return;
    if (e.target.className == 'add-event-button') return;
    this.toggle();
  }

  clickProvider(e) {
    let clicked = $(e.target);
    let url = clicked.attr('data-href');
    window.open(url,'_blank');
    this.toggle();
  }

}
